'use strict';

class LoadingController {
    constructor() {
        // this.DataService = DataService;
    }

    cancelRequest() {
        // this.DataService.cancelRequest();
    }
}

export default LoadingController;


// WEBPACK FOOTER //
// ./src/app/common/layout/loading/loading.controller.js